
// 倒入所有接口
import apiSpecTracker from './apiSpecTracker'
import apiReport from './apiReport'
import apiSystem from './apiSystem'

const install = Vue => {
  if (install.installed)
    return;
  install.installed = true;

  Vue.prototype.apiSpecTracker = apiSpecTracker;
  Vue.prototype.apiSystem = apiSystem;
  Vue.prototype.apiReport = apiReport;
}

export default install



// WEBPACK FOOTER //
// ./src/api/index.js